'use client';

import React, { createContext, useContext } from 'react';
import { useUserPlanState } from '@/creditflowresearch/application/User/UserPlan/hooks/useUserPlanState';
import { IUserPlanContext, IUserPlanState } from '@/creditflowresearch/application/User/UserPlan/types';
import { initUserPlan } from '@/creditflowresearch/application/User/UserPlan/initialState';

const useUserPlan = (initial: IUserPlanState): IUserPlanContext => {
  return useUserPlanState(initial);
};

type UserPlanContextType = ReturnType<typeof useUserPlan>;

export const UserPlanContext = createContext<UserPlanContextType | null>(null);

export const useUserPlanContext = (): IUserPlanContext => {
  const context = useContext(UserPlanContext);
  if (!context) {
    throw new Error('useUserPlanContext must be used within the UserPlanContext');
  }
  return context;
};

interface IProps {
  userPlanState?: IUserPlanState,
  children: React.ReactNode,
}

const UserPlanContextProvider = ({ children, userPlanState }: IProps) => {
  const value = useUserPlan(userPlanState || initUserPlan);

  return (
    <UserPlanContext.Provider value={ value }>
      { children }
    </UserPlanContext.Provider>
  );
};

export default UserPlanContextProvider;
